$(function() {
    $('.js-consent-newsletter .c-form__input').on('change', function() {
        $(this).parents('form').trigger('submit');
    });
});
